module.exports = __webpack_public_path__ + "static/media/img-boxfit-screen@2x.f287085a.png";